import React from "react";
import styled from "styled-components";

export default function MoleculeContentTypeSelectPopup({
  onClose,
  onSelectGeneral,
  onSelectMeal,
  onSelectLink,
  onSelectImage,
  onSelectCustom,
  excludeContent = false,
  customerType = "education",
}) {
  return (
    <>
      <Overlay onClick={onClose} />
      <PopupContainer>
        <Header>
          <Heading>콘텐츠 유형 선택</Heading>
          <IconButton onClick={onClose}>
            <CloseSvg />
          </IconButton>
        </Header>

        <ContentSection>
          <Description>생성할 콘텐츠의 유형을 선택해주세요.</Description>

          <ButtonContainer>
            <ContentTypeButton onClick={onSelectGeneral}>
              <ButtonIcon>
                <GeneralContentSvg />
              </ButtonIcon>
              <ButtonContent>
                <ButtonTitle>일반 콘텐츠</ButtonTitle>
                <ButtonDescription>
                  {excludeContent
                    ? "공지사항, 일정을 포함한 일반적인 콘텐츠를 생성합니다."
                    : "학급 소식, 공지사항, 일정을 포함한 일반적인 콘텐츠를 생성합니다."}
                </ButtonDescription>
              </ButtonContent>
            </ContentTypeButton>

            <ContentTypeButton onClick={onSelectMeal}>
              <ButtonIcon>
                <MealContentSvg />
              </ButtonIcon>
              <ButtonContent>
                <ButtonTitle>식단 콘텐츠</ButtonTitle>
                <ButtonDescription>
                  식단 메뉴와 영양 정보를 포함한 식단 전용 콘텐츠를 생성합니다.
                </ButtonDescription>
              </ButtonContent>
            </ContentTypeButton>

            {customerType === "education" && (
              <ContentTypeButton onClick={onSelectLink}>
                <ButtonIcon>
                  <LinkContentSvg />
                </ButtonIcon>
                <ButtonContent>
                  <ButtonTitle>링크 콘텐츠</ButtonTitle>
                  <ButtonDescription>
                    링크 전용 콘텐츠를 생성합니다.
                  </ButtonDescription>
                </ButtonContent>
              </ContentTypeButton>
            )}
            {customerType === "info" && (
              <ContentTypeButton onClick={onSelectImage}>
                <ButtonIcon>
                  <ImageContentSvg />
                </ButtonIcon>
                <ButtonContent>
                  <ButtonTitle>이미지 콘텐츠</ButtonTitle>
                  <ButtonDescription>
                    이미지 전용 콘텐츠를 생성합니다.
                  </ButtonDescription>
                </ButtonContent>
              </ContentTypeButton>
            )}

            {onSelectCustom && (
              <ContentTypeButton onClick={onSelectCustom}>
                <ButtonIcon>
                  <CustomContentSvg />
                </ButtonIcon>
                <ButtonContent>
                  <ButtonTitle>커스텀 콘텐츠</ButtonTitle>
                  <ButtonDescription>
                    마크다운을 직접 작성하여 커스텀 콘텐츠를 생성합니다.
                  </ButtonDescription>
                </ButtonContent>
              </ContentTypeButton>
            )}
          </ButtonContainer>
        </ContentSection>
      </PopupContainer>
    </>
  );
}

// SVG 아이콘들
const CloseSvg = ({ fill = "#33363D", width = 24, height = 24, ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L12 10.5858L6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L10.5858 12L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.29289 18.7071C5.68342 19.0976 6.31658 19.0976 6.70711 18.7071L12 13.4142L17.2929 18.7071C17.6834 19.0976 18.3166 19.0976 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929L13.4142 12L18.7071 6.70711Z"
      fill={fill}
    />
  </svg>
);

const GeneralContentSvg = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" height="48" rx="8" fill="#ECF2FE" />
    <path
      d="M12 16H36V18H12V16ZM12 22H36V24H12V22ZM12 28H28V30H12V28ZM32 28H36V30H32V28Z"
      fill="#256EF4"
    />
  </svg>
);

const MealContentSvg = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" height="48" rx="8" fill="#FEF3E2" />
    <path
      d="M16 14V20C16 22.2091 17.7909 24 20 24H28C30.2091 24 32 22.2091 32 20V14H30V20C30 21.1046 29.1046 22 28 22H20C18.8954 22 18 21.1046 18 20V14H16ZM14 26H34V28H32V32C32 33.1046 31.1046 34 30 34H18C16.8954 34 16 33.1046 16 32V28H14V26ZM18 28V32H30V28H18Z"
      fill="#F59E0B"
    />
  </svg>
);

// 링크 콘텐츠용 SVG 아이콘
const LinkContentSvg = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" height="48" rx="8" fill="#EAFDF7" />
    <path
      d="M18.5 24c0-1.4.56-2.75 1.56-3.74l3.2-3.2a5.29 5.29 0 0 1 7.48 0 5.3 5.3 0 0 1 0 7.49l-2.19 2.19a.9.9 0 0 1-1.27-1.27l2.19-2.19a3.5 3.5 0 0 0-4.95-4.95l-3.2 3.2a3.5 3.5 0 0 0 0 4.95.9.9 0 1 1-1.27 1.27A5.27 5.27 0 0 1 18.5 24Z"
      fill="#0D9488"
    />
    <path
      d="M29.5 24c0 1.4-.56 2.75-1.56 3.74l-3.2 3.2a5.29 5.29 0 0 1-7.48 0 5.3 5.3 0 0 1 0-7.49l2.19-2.19a.9.9 0 0 1 1.27 1.27l-2.19 2.19a3.5 3.5 0 0 0 4.95 4.95l3.2-3.2a3.5 3.5 0 0 0 0-4.95.9.9 0 1 1 1.27-1.27A5.27 5.27 0 0 1 29.5 24Z"
      fill="#0D9488"
    />
  </svg>
);

// 이미지 콘텐츠용 SVG 아이콘
const ImageContentSvg = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" height="48" rx="8" fill="#E9FBF3" />
    <rect
      x="11"
      y="12"
      width="26"
      height="24"
      rx="3"
      fill="#D7F5E7"
      stroke="#22C55E"
      strokeWidth="2"
    />
    <path
      d="M14 29.5L20.5 22.5L27.5 30L32 26L36 30V33C36 34.1046 35.1046 35 34 35H14C12.8954 35 12 34.1046 12 33V30.5L14 29.5Z"
      fill="#22C55E"
      fillOpacity="0.18"
      stroke="#22C55E"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <circle cx="18" cy="19" r="3" fill="#22C55E" fillOpacity="0.28" stroke="#22C55E" strokeWidth="2" />
  </svg>
);

// 커스텀 콘텐츠용 SVG 아이콘
const CustomContentSvg = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" height="48" rx="8" fill="#F3E8FF" />
    <path
      d="M16 16H32V18H16V16ZM16 22H32V24H16V22ZM16 28H28V30H16V28ZM30 28H32V30H30V28Z"
      fill="#9333EA"
    />
    <path
      d="M20 34C20 35.1046 20.8954 36 22 36H26C27.1046 36 28 35.1046 28 34V32H20V34Z"
      fill="#9333EA"
    />
  </svg>
);

// 스타일 컴포넌트들
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.1);
  z-index: 999;
`;

const PopupContainer = styled.div`
  width: 560px;
  padding: 40px;
  background: white;
  border-radius: 20px;
  outline: 1px solid #e0e4eb;
  display: flex;
  flex-direction: column;
  gap: 32px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Heading = styled.span`
  color: #131416;
  font-size: 24px;
  font-weight: 700;
  line-height: 36px;
`;

const IconButton = styled.button`
  width: 24px;
  height: 24px;
  background: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Description = styled.p`
  font-size: 16px;
  color: #666666;
  margin: 0;
  text-align: left;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ContentTypeButton = styled.button`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  background: white;
  border: 2px solid #e0e4eb;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;

  &:hover {
    border-color: #256ef4;
    background: #fafbfc;
  }
`;

const ButtonIcon = styled.div`
  flex-shrink: 0;
`;

const ButtonContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`;

const ButtonTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #323232;
  margin: 0;
`;

const ButtonDescription = styled.p`
  font-size: 14px;
  color: #666666;
  margin: 0;
  line-height: 1.4;
`;
